import React from 'react';
import { IOrder } from '../../../types';

export function OrderNames({
  order,
  field,
}: {
  order: IOrder;
  field: 'brands' | 'kitchens';
}) {
  const entries = [order, ...(order.checkoutOrders ?? [])].flatMap<{
    id: number;
    name: string;
  }>((portion) => portion[field] ?? []);
  const unique = entries.filter(
    (entry, index) =>
      entries.findIndex((other) => other.id === entry.id) === index
  );
  if (!unique.length) return <>—</>;
  const name = (entry: (typeof unique)[number]) => (
    <div
      key={entry.id}
      className="max-w-[220px] whitespace-normal break-words leading-5"
    >
      {entry.name}
    </div>
  );
  return (
    <div>
      {unique.slice(0, 2).map(name)}
      {unique.length > 2 && (
        <details onClick={(event) => event.stopPropagation()}>
          <summary className="min-h-[28px] cursor-pointer text-xs leading-7 text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary">
            +{unique.length - 2} more
            <span className="sr-only">
              {' '}
              {field === 'brands' ? 'vendors' : 'outlets'}
            </span>
          </summary>
          {unique.slice(2).map(name)}
        </details>
      )}
    </div>
  );
}
